export default __webpack_public_path__ + "static/media/27.96d28789.jpg";